export const UPDATE_COUNTER = 'UPDATE_COUNTER';
export const PHONE_NUMBER = '+918000750634';
export const RESET_COUNTER = 'RESET_COUNTER';
export const CHAT_NUMBER = '+918000750634';
export const EMAIL_ID = 'mailto:deepak@quicksell.co';
export const ATTACH_FIREBASE_LISTENERS = 'ATTACH_FIREBASE_LISTENERS';
